// src/slices/videoToggleSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { getVideoToggleState, setVideoToggleState } from '../../services/storage/GQStorage';

const persistedState = getVideoToggleState() || { videoToggle: true };

const videoToggleSlice = createSlice({
  name: 'videoToggle',
  initialState: persistedState,
  reducers: {
    setVideoToggle: (state, action) => {
      state.videoToggle = action.payload;
    },
  },
});

export const { setVideoToggle } = videoToggleSlice.actions;
export const videoToggleReducer = videoToggleSlice.reducer;

export const persistVideoToggleMiddleware = store => next => action => {
  const result = next(action);
  setVideoToggleState(store.getState().setVideoToggle);
  return result;
};
export default videoToggleSlice;
